export default __webpack_public_path__ + "static/media/contract_sold.09507182.png";